import { FEEDBACK_MODEL_STATUS, FEEDBACK_MODEL_STATUS_TO_FEEDBACK_DOMAIN_LIST_PATH } from '../../constants'
import { FEEDBACK_MODEL_KEY } from '../../../../modules/feedback/model'
import addInstanceToDomainListReduxUtil from '../../../../modules/redux/utils/add-instance-to-domain-list'
import deleteInstanceFromDomainReduxUtil from '../../../../modules/redux/utils/delete-instance-from-domain'
import { getValueReduxUtil } from '../../../../modules/redux/utils/get-value'

function afterCreateFeedbackHook (instance, state) {
  const status = (
    getValueReduxUtil(instance, FEEDBACK_MODEL_KEY.STATUS) ||
    FEEDBACK_MODEL_STATUS.OPEN
  )
  // If the feedback was closed by the user and not the admin,
  // remove it from the open domain list
  if (status === FEEDBACK_MODEL_STATUS.CLOSED) {
    state = deleteInstanceFromDomainReduxUtil({
      state,
      instance,
      domainListPath: FEEDBACK_MODEL_STATUS_TO_FEEDBACK_DOMAIN_LIST_PATH[FEEDBACK_MODEL_STATUS.OPEN]
    })
  }
  const path = FEEDBACK_MODEL_STATUS_TO_FEEDBACK_DOMAIN_LIST_PATH[status]
  state = addInstanceToDomainListReduxUtil({
    state,
    instance,
    domainListPath: path
  })
  return state
}

export default afterCreateFeedbackHook
